import React from 'react'
import { Box } from '@ally/metronome-ui'
import { CustomerDomain, AfgCustomerDomain } from '@ally/data-types-host'

import { isBirthdayWeek } from '../utils/birthday'
import { StyledBadgeIcon, StyledBadgeHeading } from './StyledComponents'

import BirthdayBadgeIcon from '../../../../static-assets/images/badges/birthday/birthday.svg'

interface Props {
  legacyCustomer: CustomerDomain | null
  afgCustomer: AfgCustomerDomain | null
}

const BirthdayBadge: React.FC<Props> = ({ legacyCustomer, afgCustomer }) => {
  const legacyBirthday = legacyCustomer?.customer?.birthDatePvtEncrypt
  const afgBirthday = afgCustomer?.data?.dob
  const birthday = legacyBirthday ?? afgBirthday ?? ''
  const showBirthdayBadge = isBirthdayWeek(birthday)

  if (showBirthdayBadge) {
    return (
      <Box display="flex" flexDirection="row">
        <StyledBadgeIcon>
          <BirthdayBadgeIcon
            data-testid="birthday-badge"
            title="Illustration: Mint green circular badge featuring a slice of triple layer pink birthday cake with frosting, sprinkles, and a lit candle ready for you to make a wish. "
          />
        </StyledBadgeIcon>
        <Box
          marginRight="sm"
          borderBottom="1px solid"
          borderColor="slate-2"
          width="100%"
        >
          <StyledBadgeHeading>Happy Birthday Week</StyledBadgeHeading>
          <p>Celebrating you and another trip around the sun!</p>
        </Box>
      </Box>
    )
  }

  return null
}

export { BirthdayBadge }
